const SaveLoginModal = ({
  modalData,
  setModalData,
  isWebMode = false,
  canUseVault = false,
  onClose,
  onConfirm
}) => {
  if (!modalData) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/60 p-4 backdrop-blur">
      <div className="glass-panel w-full max-w-md rounded-2xl p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-xs font-semibold text-textMuted">Save login</p>
            <h3 className="text-lg font-semibold text-white m-0">Save & connect</h3>
          </div>
          <button type="button" className="ghost-button" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="mt-4 space-y-3">
          <input
            className="w-full rounded-lg border border-border bg-inset/70 px-3 py-2 text-sm text-white placeholder:text-textMuted focus:border-accent focus:outline-none"
            value={modalData.name}
            onChange={(e) => setModalData((prev) => ({ ...prev, name: e.target.value }))}
            placeholder="Friendly name" />

          <textarea
            className="w-full rounded-lg border border-border bg-inset/70 px-3 py-2 text-sm text-white placeholder:text-textMuted focus:border-accent focus:outline-none min-h-[90px] resize-none"
            value={modalData.description}
            onChange={(e) => setModalData((prev) => ({ ...prev, description: e.target.value }))}
            placeholder="Optional description" />

          {isWebMode ?
            <div className="space-y-2">
              <p className="text-xs text-textMuted">Login will be saved in your browser storage.</p>
              {canUseVault ?
                <label className="flex items-center gap-2 text-sm text-textMuted">
                  <input
                    type="checkbox"
                    checked={modalData.encrypt}
                    onChange={(e) => setModalData((prev) => ({ ...prev, encrypt: e.target.checked }))} />
                  Encrypt with a master password
                </label> :
                null}
            </div> :
            canUseVault ?
              <label className="flex items-center gap-2 text-sm text-textMuted">
                <input
                  type="checkbox"
                  checked={modalData.encrypt}
                  onChange={(e) => setModalData((prev) => ({ ...prev, encrypt: e.target.checked }))} />
                Save to vault (requires master password)
              </label> :
              <p className="text-xs text-textMuted">Vault is not available.</p>}
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" className="ghost-button" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="pill-button px-4 py-2"
            onClick={onConfirm}
            disabled={!modalData.name}>
            Save & Connect
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveLoginModal;
